export default __webpack_public_path__ + "static/media/api.f322bd4c.svg";